import { Effect } from "../../../redux/types/effect.type";
import { EffectActionsObservable } from "../../../redux/types/effect-actions-observable.type";
import { catchError, filter, ignoreElements, map, mergeMap, tap } from "rxjs/operators";
import { isActionType } from "../../../redux/action.functions";
import * as authService from "../services/auth.service";
import { of } from "rxjs";
import * as uiActions from "../../ui/store/ui.actions";
import * as navigationService from "../../navigation/services/navigation.service";
import { AuthActions } from "./auth.actions";
import * as actions from "./auth.actions";
import * as userActions from "../../user/store/user.actions";

export const authenticate: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.Authenticate)),
    mergeMap(() =>
      authService.authenticate().pipe(
        map((credentials) => actions.authenticateSuccess(credentials.userId)),
        catchError((error) => of(actions.authenticateFailure(error)))
      )
    )
  );

export const authenticateSuccess: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.AuthenticateSuccess)),
    map((action) => action.payload),
    map((userId) => userActions.fetchUserData(userId))
  );

export const authenticateFailure: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.AuthenticateFailure)),
    map((action) => action.payload),
    tap(() => navigationService.goToLogin()),
    mergeMap((error) => of(uiActions.setErrors(error)))
  );

export const destroySession: Effect = (action$: EffectActionsObservable) =>
  action$.pipe(
    filter(isActionType(AuthActions.DestroySession)),
    tap(() => authService.destroySession()),
    tap(() => navigationService.goToLogin()),
    ignoreElements()
  );

export const AuthEffects = [authenticate, authenticateFailure, destroySession, authenticateSuccess];
